import { MktButtonTypes, MktButtonStylesType } from './button.types';

export const defaultButtonStyles =
  'whl-px-[30px] whl-py-[11px] lg:whl-px-7 lg:whl-py-[17px] whl-min-w-[200px] whl-h-6 lg:whl-h-[60px] lg:whl-min-w-[240px] whl-rounded-[40px] whl-font-bold whl-tracking-[0.4px]';

export const MktButtonStyles: MktButtonStylesType = {
  [MktButtonTypes.primary]:
    'whl-bg-gold whl-text-white hover:whl-bg-[transparent]  hover:whl-border-[1px] hover:whl-text-gold hover:whl-border-gold',
  [MktButtonTypes['secondary-light']]:
    'whl-bg-white whl-text-blue-dark hover:whl-bg-[transparent]  hover:whl-border-[1px] hover:whl-border-white hover:whl-text-white ',
  [MktButtonTypes['secondary-dark']]:
    'whl-bg-blue-dark whl-text-white hover:whl-bg-[transparent]  hover:whl-border-[1px] hover:whl-text-blue-dark hover:whl-border-blue-dark',
  [MktButtonTypes.light]:
    'whl-bg-blue-light whl-text-blue-dark hover:whl-bg-[transparent]  hover:whl-border-[1px] hover:whl-text-blue-light hover:whl-border-blue-light',
};
